export default __webpack_public_path__ + "static/trackrecordimg_3-5907210dcde39aaec3c5236acff46399.png";